<template>
  <div class="descriptifs" >
    <div class="descriptifs__wrapper" v-if="stepSelected">
      <component :is="firstCard" class="descriptifs__wrapper__elem" />
      <component :is="secondCard" class="descriptifs__wrapper__elem" />
      <component :is="thirdCard" class="descriptifs__wrapper__elem" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'descriptifsCards',
  props: {
    stepSelected: {
      type: Object,
    },
  },
  computed: {
    firstCard() {
      return this.getCardComponent(1);
    },
    secondCard() {
      return this.getCardComponent(2);
    },
    thirdCard() {
      return this.getCardComponent(3);
    },
  },
  methods: {
    getCardComponent(cardNum) {
      const path = './smallCards/';
      const { descriptifCards } = this.stepSelected;
      return () => import(`${path}${descriptifCards[cardNum - 1]}.vue`);
    },
  },
};
</script>

<style scoped lang="scss">
.descriptifs {
  padding: 0;
  @include breakpoint(tablet) {
    margin: 0 20px 20px;
  }
  @include breakpoint(wide) {
    margin: 0 $--wide-margin 20px;
  }
  @include breakpoint(wide-xl) {
    margin: 0 $--wide-xl-margin 20px;
  }
  &__wrapper {
    display: flex;
    flex-direction: column;
    @include breakpoint(tablet) {
      flex-direction: row;
    }
    &__elem {
      flex: 1 1 0%;
      &:nth-child(1) {
        @include breakpoint(tablet) {
          margin-right: 10px;
        }
      }
      &:nth-child(2) {
        @include breakpoint(tablet) {
          margin-left: 10px;
          margin-right: 10px;
        }
      }
      &:nth-child(3) {
        @include breakpoint(tablet) {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
